// lib
import { connect } from "react-redux";
import moment from "moment";
// src
import Component from "components/plannings/partials/datePicker/DatePicker";

const mapStateToProps = ({
  timeline: { start, end },
  table: { focus, view },
  ux: { language },
}) => ({
  focus: new Date(focus),
  language,
  timelineStart: moment(start).startOf("day").valueOf(),
  timelineEnd: moment(end).endOf("day").valueOf(),
  view,
});

export default connect(mapStateToProps)(Component);
